import { existsSync, readFileSync, writeFileSync, mkdirSync } from "fs";
import { join, dirname } from "path";
var WARM_DEPS_FILE = "one-warm-deps.json";
var TRACKING_WINDOW = 5 * 60 * 1e3;
function autoWarmPlugin(persistPath) {
  var cacheFile;
  var cachedDeps = [];
  var excludeSet;
  return {
    name: "one:auto-warm",
    apply: "serve",
    config() {
      var volatileCache = join(process.cwd(), "node_modules", ".vite", WARM_DEPS_FILE);
      cacheFile = typeof persistPath === "string" ? join(process.cwd(), persistPath) : volatileCache;
      try {
        if (existsSync(cacheFile)) {
          var cached = JSON.parse(readFileSync(cacheFile, "utf-8"));
          if (Array.isArray(cached.deps) && cached.deps.length > 0) {
            cachedDeps = cached.deps;
            console.info(`[one] loading ${cached.deps.length} cached warm deps`);
            return {
              optimizeDeps: {
                include: cached.deps
              }
            };
          }
        }
      } catch (unused) {
      }
    },
    // cache corrupted, ignore
    async configResolved(config) {
      excludeSet = new Set(config.optimizeDeps.exclude || []);
      if (cachedDeps.length > 0) {
        var resolve = config.createResolver();
        var staleDeps = /* @__PURE__ */ new Set();
        await Promise.all(cachedDeps.map(async function(dep) {
          if (excludeSet.has(dep)) {
            staleDeps.add(dep);
            return;
          }
          try {
            if (!await resolve(dep)) staleDeps.add(dep);
          } catch (unused) {
            staleDeps.add(dep);
          }
        }));
        if (staleDeps.size > 0) {
          cachedDeps = cachedDeps.filter(function(dep) {
            return !staleDeps.has(dep);
          });
          console.info(`[one] pruned ${staleDeps.size} stale deps from warm cache`);
          if (config.optimizeDeps.include) {
            config.optimizeDeps.include = config.optimizeDeps.include.filter(function(dep) {
              return !staleDeps.has(dep);
            });
          }
          try {
            var nextRaw = JSON.stringify({
              deps: [
                ...cachedDeps
              ].sort()
            }, null, 2);
            if (!existsSync(cacheFile) || readFileSync(cacheFile, "utf-8") !== nextRaw) {
              var dir = dirname(cacheFile);
              if (!existsSync(dir)) mkdirSync(dir, {
                recursive: true
              });
              writeFileSync(cacheFile, nextRaw);
            }
          } catch (unused) {
          }
        }
      }
    },
    // a future snapshot can retry the cache write
    configureServer(server) {
      var _server_httpServer;
      var lastDepsCount = 0;
      var timer;
      var userInclude = new Set((server.config.optimizeDeps.include || []).filter(function(d) {
        return !cachedDeps.includes(d);
      }));
      function snapshotDeps() {
        try {
          var _ref;
          var _server_environments_client, _server_environments;
          var optimizer = (_ref = (_server_environments = server.environments) === null || _server_environments === void 0 ? void 0 : (_server_environments_client = _server_environments.client) === null || _server_environments_client === void 0 ? void 0 : _server_environments_client.depsOptimizer) !== null && _ref !== void 0 ? _ref : server._depsOptimizer;
          if (!(optimizer === null || optimizer === void 0 ? void 0 : optimizer.metadata)) return;
          var optimized = optimizer.metadata.optimized;
          var discovered = optimizer.metadata.discovered;
          var currentDeps = [
            ...Object.keys(optimized || {}),
            ...Object.keys(discovered || {})
          ];
          if (currentDeps.length === 0 || currentDeps.length === lastDepsCount) return;
          lastDepsCount = currentDeps.length;
          var depsToCache = currentDeps.filter(function(d2) {
            return !userInclude.has(d2) && !excludeSet.has(d2);
          });
          var allDeps = new Set(depsToCache);
          var existingRaw;
          if (existsSync(cacheFile)) {
            try {
              existingRaw = readFileSync(cacheFile, "utf-8");
              var existing = JSON.parse(existingRaw);
              if (Array.isArray(existing.deps)) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
                try {
                  for (var _iterator = existing.deps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var d = _step.value;
                    if (!excludeSet.has(d)) allDeps.add(d);
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }
              }
            } catch (unused) {
              return;
            }
          }
          var sorted = [
            ...allDeps
          ].sort();
          var nextRaw = JSON.stringify({
            deps: sorted
          }, null, 2);
          if (existingRaw === nextRaw) return;
          var dir = dirname(cacheFile);
          if (!existsSync(dir)) mkdirSync(dir, {
            recursive: true
          });
          writeFileSync(cacheFile, nextRaw);
          console.info(`[one] cached ${sorted.length} deps for next startup`);
        } catch (unused) {
        }
      }
      (_server_httpServer = server.httpServer) === null || _server_httpServer === void 0 ? void 0 : _server_httpServer.once("listening", function() {
        timer = setInterval(snapshotDeps, 5e3);
        setTimeout(function() {
          clearInterval(timer);
          snapshotDeps();
        }, TRACKING_WINDOW);
      });
      var origClose = server.close.bind(server);
      server.close = async function() {
        clearInterval(timer);
        snapshotDeps();
        return origClose();
      };
    }
  };
}
var warmRoutesPlugin = autoWarmPlugin;
export {
  autoWarmPlugin,
  warmRoutesPlugin
};
//# sourceMappingURL=warmRoutesPlugin.js.map
